import React, { useCallback, useMemo } from "react";

// Navigate
import Box from "@mui/material/Box";
import { useNavigate, useParams } from "react-router-dom";

// Components
import RosterLocationDialog from "@/components/Dialog/rosterLocationDialog";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { Typography } from "@mui/material";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";

// Fetch
import {
  deleteRosterByUser,
  getPublicHolidays,
  getRosterByUser,
  upsertRosterByUser,
} from "@/fetch/fetchRoster";

import { getUserDetail } from "@/fetch/fetchStaff";
import { useCurrentAction } from "@/hooks/user";
import getDateRange from "@/lib/getDateRange";
import PersonIcon from "@mui/icons-material/Person";
import _ from "lodash";
import "react-big-calendar/lib/css/react-big-calendar.css";
const SystemSettingUserRosterPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const [isDialogOpen, setDialogOpen] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState({});
  const [events, setEvents] = React.useState([]);
  const [workingDayCount, setWorkingDayCount] = React.useState(0);
  const [baseLocation, setBaseLocation] = React.useState(null);
  const [offDayCount, setOffDayCount] = React.useState(0);
  const [leaveDayCount, setLeaveDayCount] = React.useState(0);
  const [currentMonth, setCurrentMonth] = React.useState(moment().format("MM"));
  const [currentYear, setCurrentYear] = React.useState(moment().format("YYYY"));
  const [holidays, setHolidays] = React.useState({});
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  // Navigate
  const navigate = useNavigate();
  const localizer = momentLocalizer(moment);
  const params = useParams();
  const eventPropGetter = useCallback((event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: event.backgroundColor,
        color: "black",
      },
    };
  }, []);
  const [event, setEvent] = React.useState({});
  const { defaultDate } = useMemo(
    () => ({
      defaultDate: moment(params.date),
    }),
    [params.date]
  );
  const handleSelectSlot = ({ start, end }) => {
    const isRosterExist = events.findIndex(
      (e) => e.start.format("YYYY-MM-DD") === moment(start).format("YYYY-MM-DD")
    );
    if (isRosterExist < 0) {
      setDialogOpen(true);
      setEvent({
        is_leave: false,
        leave_type: "",
        location_id: null,
        start_date: moment(start).format("YYYY-MM-DD"),
        end_date: moment(end).subtract(1, "days").format("YYYY-MM-DD"),
        start_time: null,
        end_time: null,
        roster: "FULL",
        roster_value: "FULL",
        is_off: false,
        street: null,
      });
    }
  };

  const handleOnChange = (value, key) => {
    setEvent((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };
  const handleOnShopChange = (value) => {
    setEvent((prev) => {
      return {
        ...prev,
        ...value,
      };
    });
  };
  const handleSelectEvent = useCallback((event) => {
    setDialogOpen(true);
    const start_time = event.start_time
      ? moment(`${event.date} ${event.start_time}`)
      : null;
    const end_time = event.end_time
      ? moment(`${event.date} ${event.end_time}`)
      : null;
    setEvent({
      ...event,
      start_date: event.date,
      end_date: event.date,
      start_time,
      end_time,
    });
  }, []);
  const onRangeChange = (range) => {
    const dateRange = getDateRange(range.start, range.end);
    const middleDate = dateRange[parseInt(dateRange.length / 2)];
    setCurrentMonth(moment(middleDate).format("MM"));
    setCurrentYear(moment(middleDate).format("YYYY"));
  };
  const handleSubmit = async (transfer) => {
    try {
      let payload = [];
      const dataRanges = getDateRange(event.start_date, event.end_date);
      let is_off = false;
      let is_leave = false;
      let leave_type = null;
      let location_id = null;
      let roster = null;
      let street = null;
      let start_time = null;
      let end_time = null;
      let lunch = null;
      let off_type = null;
      let remark = null;
      if (event.is_off) {
        is_off = true;
        off_type = event.value;
        remark = event.remark;
      } else if (event.is_leave) {
        is_leave = true;
        leave_type = event.value;
        remark = event.remark;
      } else {
        location_id = event.value;
        roster = event.roster_value ?? "FULL";
        street = event.street;
        start_time = event.start_time
          ? moment(event.start_time).format("HH:mm")
          : null;
        end_time = event.end_time
          ? moment(event.end_time).format("HH:mm")
          : null;
        lunch = event.lunch;
      }
      payload = _.map(dataRanges, (dataRange) => {
        return {
          date: moment(dataRange).format("YYYY-MM-DD"),
          is_off,
          off_type,
          is_leave,
          leave_type,
          location_id,
          user_id: params.user_id,
          roster,
          street,
          start_time,
          end_time,
          lunch,
          remark,
          time_checkedin: event.time_checkedin,
          time_checkedout: event.time_checkedout,
        };
      });
      setSnackSeverity("success");
      setSnackMessage("更新成功");
      setSnackOpen(true);
      await upsertRosterByUser(payload, transfer);
    } catch (err) {
      setSnackSeverity("errro");
      setSnackMessage(`更新失敗\n${err.message}`);
      setSnackOpen(true);
    } finally {
      setDialogOpen(false);

      fetchAll();
    }
  };
  const handleDelete = async () => {
    const answer = window.confirm("確定要刪除嗎，會連同打卡紀錄一起刪除？");
    if (answer) {
      await deleteRosterByUser(event.user_id, event.date);
      setDialogOpen(false);

      fetchAll();
    }
  };
  // Fetch
  const fetchAll = async () => {
    const { user_id } = params;
    const date = `${currentYear}-${currentMonth}`;
    const start = moment(`${currentYear}-${currentMonth}`)
      .subtract(1, "month")
      .startOf("month")
      .format("YYYY-MM-DD");
    const end = moment(`${currentYear}-${currentMonth}`)
      .add(1, "month")
      .endOf("month")
      .format("YYYY-MM-DD");
    const { data: user } = await getUserDetail(user_id);
    const rosters = await getRosterByUser(user_id, start, end);
    const { data: holidaysData } = await getPublicHolidays();
    setHolidays(holidaysData);
    const formattedEvent = [];
    let title = "";
    setWorkingDayCount(0);
    setOffDayCount(0);
    setLeaveDayCount(0);
    _.forEach(rosters.data, (roster) => {
      let backgroundColor = "#fde9d9";
      if (
        (roster.is_off && roster.replace_user_id) ||
        (roster.is_off && !roster.replace_user_id)
      ) {
        if (moment(roster.date).format("MM") === moment(date).format("MM")) {
          setOffDayCount((prev) => prev + 1);
        }
        title = `${roster.off_type} ${roster.remark ?? ""}`;
        backgroundColor = "#d09996";
      } else if (
        (roster.replace_user_id && roster.is_leave) ||
        (roster.is_leave && !roster.replace_user_id)
      ) {
        if (
          moment(roster.date).format("MM") === moment(date).format("MM") &&
          roster.value === "ANL"
        ) {
          setLeaveDayCount((prev) => prev + 1);
        }
        title = `${roster.leave_type} ${roster.remark ?? ""}`;
        backgroundColor = "#deedf2";
      } else {
        if (moment(roster.date).format("MM") === moment(date).format("MM")) {
          setWorkingDayCount((prev) => prev + 1);
          setBaseLocation(roster.base_location_name);
        }
        title = `${roster.work_name} (${roster.roster}) ${
          roster.street ? `(${roster.street}街)` : ""
        } ${roster.remark ?? ""}`;
      }
      formattedEvent.push({
        title,
        ...roster,
        start: moment(roster.date),
        end: moment(roster.date),
        backgroundColor,
      });
      //   if (lastTitle === title) {
      //     const lastIndex = formattedEvent.length - 1;
      //     formattedEvent[lastIndex].end = new Date(roster.date);
      //   } else {
      //     formattedEvent.push({
      //       title,
      //       start: new Date(roster.date),
      //       end: new Date(roster.date),
      //       ...roster,
      //       backgroundColor,
      //     });
      //   }
    });
    setCurrentUser(user);
    setEvents(formattedEvent);
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMonth]);
  const DateCellContent = (props) => {
    const { date } = props;
    const dayOfWeek = date.getDay();
    return (
      <Box
        component="span"
        style={{
          color:
            dayOfWeek === 0 || holidays[moment(date).format("YYYY-MM-DD")]
              ? "red"
              : "",
        }}
      >
        <Typography>{props.label}</Typography>

        {holidays[moment(date).format("YYYY-MM-DD")] && (
          <Typography>{holidays[moment(date).format("YYYY-MM-DD")]}</Typography>
        )}
      </Box>
    );
  };
  return (
    <Layout
      header="RosterPage"
      selectedIndex={22}
      open={open}
      setOpen={setOpen}
      snackClose={() => setSnackOpen(false)}
      snackSeverity={snackSeverity}
      snackMessage={snackMessage}
      snackOpen={snackOpen}
    >
      <Title
        history={() => navigate(-1)}
        title="更表"
        children={
          <>
            <div>
              <PersonIcon style={{ verticalAlign: "middle" }}></PersonIcon>
              {currentUser.full_name} - {baseLocation}
            </div>
            <div>
              Leave:{leaveDayCount} OFF:{offDayCount} Working:{workingDayCount}
            </div>
          </>
        }
      />

      <RosterLocationDialog
        open={isDialogOpen}
        cancelMessage={"取消"}
        submitMessage={"提交"}
        actions={actions}
        event={event}
        events={events}
        onSubmit={handleSubmit}
        handleOnChange={handleOnChange}
        handleOnShopChange={handleOnShopChange}
        onDelete={handleDelete}
        onCancel={() => setDialogOpen(!isDialogOpen)}
      ></RosterLocationDialog>
      <Calendar
        localizer={localizer}
        eventPropGetter={eventPropGetter}
        events={events}
        defaultDate={defaultDate}
        onRangeChange={onRangeChange}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={handleSelectEvent}
        onSelectSlot={handleSelectSlot}
        style={{ height: 650 }}
        views={["month"]}
        showMultiDayTimes={true}
        selectable
        messages={{
          previous: "上個月",
          next: "下個月",
          today: "今月",
        }}
        components={{
          month: {
            dateHeader: DateCellContent,
          },
        }}
      />
    </Layout>
  );
};

export default SystemSettingUserRosterPage;
